import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "@platform/root";
import { McpConnectPage } from "./mcp-connect.page";

export const mcpConnectRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/connect/$step",
	component: McpConnectPage,
});
